/** @file Short id generator. Not cryptographic — sufficient for client-side tokens/drawings. */

const ALPHABET = "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789";

/**
 * Generate a URL-safe short id. Default length 10 → 57^10 ≈ 3.6 × 10^17 combinations.
 * @param {number} [length]
 * @returns {string}
 */
export function shortId(length = 10) {
  let out = "";
  for (let i = 0; i < length; i++) {
    out += ALPHABET[Math.floor(Math.random() * ALPHABET.length)];
  }
  return out;
}
